module.exports = __webpack_public_path__ + "static/media/pg29.3c71f684.jpg";